export default {
  selected: "selected",
  applied: "applied",
  unwanted: "unwanted",
  cancelled: "cancelled",
  sick: "sick",
  double: "double",
  removed: "removed"
};
